import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomIconService } from 'src/app/core/services/custom-icon.service';

@Component({
  selector: 'app-period-modal.component',
  templateUrl: './period-modal.component.html',
  styleUrls: ['./period-modal.component.scss']
})
export class PeriodModalComponent implements OnInit {

  model: any = {};
  @ViewChild('calendar') calendar: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customIconService: CustomIconService,
  ) {
  }

  ngOnInit() {
    this.model.period = { start: new Date(this.data.period.start), end: new Date(this.data.period.end) };
    this.customIconService.init();
  }

  changePeriod($event) {
    this.model.period = $event;
    this.calendar.activeDate = this.model.period.start;
  }

  definePeriod(period) {
    switch (period) {
      case 'today':
        this.changePeriod({ start: new Date(), end: new Date() });
        break;
      case 'yesterday':
        this.changePeriod({ start: new Date(new Date().setDate(new Date().getDate() - 1)), end: new Date(new Date().setDate(new Date().getDate() - 1)) });
        break;
      case 'last7days':
        this.changePeriod({ start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() });
        break;
      case 'last30days':
        this.changePeriod({ start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() });
        break;
      case 'thisMonth':
        this.changePeriod({ start: new Date(new Date().getFullYear(), new Date().getMonth(), 1), end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0) });
        break;
      case 'lastMonth':
        this.changePeriod({ start: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), end: new Date(new Date().getFullYear(), new Date().getMonth(), 0) });
        break;
    }
  }
}
